import React from 'react';
import {t} from '@lingui/core/macro';

import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import {isTranslate} from 'shared/lib/lang';
import {CollapsiblePanel} from 'entities/tariff';
import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';
import useHttpMonitorBatchCreateForm from 'features/http/model/useHttpMonitorBatchCreateForm';

import {BatchResult, CheckInterval, GeoCheck} from 'entities/monitor';


import TextAreaBlock from './TextAreaBlock/TextAreaBlock';
import RequestMethod from './RequestMethod/RequestMethod';
import RequestHeadersField from './RequestHeadersField/RequestHeadersField';
import RequestTimeout from './RequestTimeout/RequestTimeout';
import CheckboxBlock from './CheckboxBlock/CheckboxBlock';
import DomainChecksBlock from './CheckboxBlock/DomainChecksBlock/DomainChecksBlock';
import NotifySettingsSubform from './NotifySettingsSubform/NotifySettingsSubform';

import styles from './HttpMonitorForm.module.scss';

interface IHttpMonitorBatchCreateFormProps {
    handleClose: () => void;
    // eslint-disable-next-line no-unused-vars
    onShowResultChange?: (isShowing: boolean) => void;
}

const HttpMonitorBatchCreateForm: React.FC<IHttpMonitorBatchCreateFormProps> = ({
    handleClose,
    onShowResultChange,
}) => {
    const {
        form,
        result,
        isLoading,
        progress,
        freeTariff,
        submitText,
        resultTitle,
        submit,
        handleCloseResult,
    } = useHttpMonitorBatchCreateForm({handleClose, onShowResultChange});
    const {register, formState, control, setValue, watch, getValues} = form;
    const {errors, isValid} = formState;

    return (
        <>
            {
                result
                    ? <BatchResult
                        result={result}
                        handleClose={handleCloseResult}
                        title={resultTitle}
                    />
                    : <form onSubmit={submit} className={styles.form}>
                        <ModalBodyWrapper>
                            <TextAreaBlock errors={errors} register={register}/>
                            <CheckInterval item={undefined} setValue={setValue} errors={errors} watch={watch}/>
                            <RequestMethod register={register} isFreeTariff={freeTariff} watch={watch}/>
                            {!isTranslate() && <RequestHeadersField control={control} register={register}/>}
                            <RequestTimeout setValue={setValue}/>
                            <GeoCheck control={control} setValue={setValue}/>
                        </ModalBodyWrapper>
                        <ModalBodyWrapper>
                            <CollapsiblePanel
                                title={t`Дополнительно`}
                                defaultExpanded
                                isFreeTariff={freeTariff}
                            >
                                <CheckboxBlock
                                    getValues={getValues}
                                    control={control}
                                    register={register}
                                    setValue={setValue}
                                />
                            </CollapsiblePanel>
                        </ModalBodyWrapper>
                        <ModalBodyWrapper>
                            <CollapsiblePanel
                                title={t`Мониторинг домена`}
                                defaultExpanded
                                isFreeTariff={freeTariff}
                                premiumCondition="monitor_ssl_enabled"
                            >
                                <DomainChecksBlock register={register}/>
                            </CollapsiblePanel>
                        </ModalBodyWrapper>
                        <ModalBodyWrapper>
                            <CollapsiblePanel
                                title={t`Уведомления`}
                                defaultExpanded={false}
                            >
                                <NotifySettingsSubform
                                   
                                    control={control}
                                    register={register}
                                />
                            </CollapsiblePanel>
                        </ModalBodyWrapper>
                        <ModalBlockButton
                            primaryButtonText={submitText}
                            primaryButtonType="submit"
                            primaryButtonLoading={isLoading}
                            primaryButtonDisabled={!isValid}
                            secondaryButtonOnClick={handleClose}
                            progress={progress}
                        />
                    </form>
            }
        </>
    );
};

export default HttpMonitorBatchCreateForm;
